// What deleting a web form or signup email means for this campaign, spelled
// out in the delete confirmation. Pure, so it's unit-tested. Deleting archives
// it (backend migration 0028): it's never shown or sent again, but what's
// already out keeps working.

const plural = (n, one, many) => (n === 1 ? one : many);

// formDeleteNotes: the consequences of deleting form `id` given the campaign's
// forms ({id, should_run}).
export function formDeleteNotes(id, forms) {
  const others = (forms || []).filter((f) => f.id !== id);
  const activeOthers = others.filter((f) => f.should_run);
  const notes = [];
  if (others.length === 0) {
    notes.push({ warn: true, text: "It's the campaign's only form: your embedded form will show nothing until you add another." });
  } else if (activeOthers.length === 0) {
    notes.push({ warn: true, text: "No other form is active, so the form will disappear from your site until you switch one on." });
  } else {
    notes.push({ warn: false, text: `Visitors will see your other active ${plural(activeOthers.length, "form", "forms")} instead.` });
  }
  notes.push({ warn: false, text: "Its views and signups leave the A/B results. A page someone already has open can still submit it." });
  return notes;
}

// emailDeleteNotes: the consequences of deleting signup email `id` given the
// campaign's emails ({id, should_run}) and whether it's double opt-in.
export function emailDeleteNotes(id, emails, doubleOptIn) {
  const others = (emails || []).filter((m) => m.id !== id);
  const activeOthers = others.filter((m) => m.should_run);
  const notes = [];
  if (others.length === 0) {
    notes.push({
      warn: true,
      text: doubleOptIn
        ? "It's the campaign's only signup email: new signups would get no email, so nobody could confirm."
        : "It's the campaign's only signup email: new signups would get no email.",
    });
  } else if (activeOthers.length === 0) {
    notes.push({ warn: true, text: "No other signup email is active, so new signups would get one of your paused emails." });
  } else {
    notes.push({ warn: false, text: `New signups get your other active ${plural(activeOthers.length, "email", "emails")} instead.` });
  }
  notes.push({ warn: false, text: "Emails already sent with it keep working: their confirm and unsubscribe links still work." });
  return notes;
}
